import { roundAtSecondDecimal } from './numbers';

export const roundForFrequencyPrice = (price: number, frequencyMultiplier: number): number => {
  const result = price * frequencyMultiplier;
  const priceDecimalPart = roundAtSecondDecimal(price % 1);

  if (isLikelyFromFrequencyRounding(priceDecimalPart, frequencyMultiplier)) {
    return Math.round(result);
  }
  return roundAtSecondDecimal(result);
};

// Tolerance value used to determine if rounding is needed for specific frequencies.
const TOLERANCE_FOR_FREQUENCY_ROUNDING = 0.005;

const isLikelyFromFrequencyRounding = (priceDecimalPart: number, frequencyMultiplier: number): boolean => {
  const frequenciesNeedingRounding = [3, 6, 12];
  if (!frequenciesNeedingRounding.includes(frequencyMultiplier)) return false;

  for (let i = 1; i < frequencyMultiplier; i++) {
    if (Math.abs(priceDecimalPart - i / frequencyMultiplier) < TOLERANCE_FOR_FREQUENCY_ROUNDING) {
      return true;
    }
  }
  return false;
};
